var _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCupPodium = function SvgCupPodium(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.696 172.37H94.1571L50.2197 172.345L72.5575 141.289L25.0452 143.62L47.9999 124.49L55.1388 124.637L114.635 124.49L134.5 124.637L157.638 141.289H111.967L124.696 172.37Z",
    fill: "url(#paint0_linear_1280_2568)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.428 79.5923H126.501L121.764 74.4905L147.772 74.4905L155.428 79.5923Z",
    fill: "url(#paint1_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.428 79.5923H126.501L117.124 125.595H137.012L155.428 79.5923Z",
    fill: "url(#paint2_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.764 74.4905L111.599 116.755L117.405 125.531L126.501 79.5923L121.764 74.4905Z",
    fill: "url(#paint3_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3025 125.544L70.7161 125.544L62.2449 77.7758L29.0968 77.7758L45.3025 125.544Z",
    fill: "url(#paint4_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0967 77.7334L62.2448 77.7334L73.2919 71.8339L37.9746 71.8339L29.0967 77.7334Z",
    fill: "url(#paint5_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2919 71.8339L76.3434 117.901L70.8372 125.544L62.2449 77.3457L73.2919 71.8339Z",
    fill: "url(#paint6_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.853 66.6086H64.408L71.8723 58.9301H115.389L122.853 66.6086Z",
    fill: "url(#paint7_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.853 66.6086H64.408L76.609 132.593H112.335L122.853 66.6086Z",
    fill: "url(#paint8_linear_1280_2568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0735 89.0059V89.4048L98.0054 89.708L97.8413 89.8476L97.6771 89.9632L97.5129 90.0351H96.8321L95.823 89.9872H95.4466L92.283 89.9433H91.9146L89.544 90.0351L88.7711 89.9872L88.5108 89.9194L88.4187 89.8476L88.3707 89.708L88.3466 89.4726V88.9381L88.3947 88.2361L88.3707 87.8611L88.2786 87.1631V86.8121L88.3026 86.6485L88.3947 86.3892L88.655 86.3414L89.592 86.4132H89.9685L90.5051 86.3892L90.7894 86.3414L90.9295 86.2736L90.9976 86.11V84.4507L91.0216 84.0757L91.1177 82.6756V82.3246L91.0937 81.81L91.0457 81.459L91.0216 80.8767L90.9976 80.5017L91.0457 79.8954L91.0937 79.0976V78.8384L91.0216 78.6988L90.8815 78.607L90.6692 78.5831L89.8243 78.8623L89.4759 78.954L89.1235 79.0019H88.8192L88.6069 78.9102L88.5108 78.7466L88.4427 78.5113L88.4187 78.3238V77.9528L88.4668 77.3665V76.9676L88.4187 76.2416V75.8427L88.4668 75.5396L88.5589 75.4L88.675 75.3082L88.9113 75.1886L89.1115 75.1208L89.4639 74.9812L90.1406 74.7697L90.469 74.6541L91.7144 74.1834L92.0668 74.0677L93.3082 73.6688L93.6606 73.5252L94.2012 73.2699L94.6016 73.1064L94.954 73.0147L95.2383 72.9907L95.4706 73.0585L95.5867 73.2221L95.6588 73.5053L95.7069 73.7845L95.6828 74.0637L95.6348 74.9772L95.6108 75.3481V78.9939L95.5427 80.4179V80.7929L95.6348 82.2408L95.6108 82.6158L95.5187 84.0398L95.4946 84.4148L95.5867 85.8627L95.6108 86.0981L95.6828 86.2377L95.823 86.3294L96.1033 86.3533L97.7932 86.3773L97.9334 86.4251L98.0295 86.6365L98.0535 86.8001L98.0735 87.1511L98.0295 87.8492V88.2241L98.0735 89.0059Z",
    fill: "url(#paint9_linear_1280_2568)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1280_2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.152 0.0175317L119.855 1.03311C119.371 1.11036 118.924 1.3437 118.578 1.69939C118.232 2.05508 118.005 2.51469 117.93 3.01174L117.521 7.39274C117.441 7.90534 117.225 8.38505 116.895 8.77833C116.565 9.17162 116.136 9.46301 115.655 9.62001L112.316 10.5936C111.376 10.8702 110.456 11.6932 110.272 12.4356C110.088 13.178 110.701 13.5913 111.655 13.3636L118.022 11.8263C118.508 11.6939 118.947 11.4226 119.289 11.0439C119.631 10.6651 119.862 10.1945 119.954 9.68655L120.488 5.11294C120.574 4.61789 120.812 4.16412 121.167 3.81813C121.522 3.47214 121.975 3.25213 122.461 3.19034L123.824 3.03976C124.801 2.9312 128.981 1.81406 128.899 2.7701V1.49538C128.901 1.27255 128.854 1.05224 128.762 0.850469C128.67 0.6487 128.535 0.470552 128.368 0.328993C128.2 0.187434 128.004 0.0860253 127.794 0.0321465C127.584 -0.0217323 127.364 -0.0267254 127.152 0.0175317Z",
    fill: "#F8CC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.428 5.07788C123.289 27.221 109.642 29.7459 104.706 29.9421C103.725 29.9771 102.927 30.5479 102.927 31.3429C102.927 32.1378 103.725 32.7857 104.709 32.7437C123.507 31.6931 127.738 14.1551 128.668 5.10589L125.428 5.07788Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3604 12.4355C75.1696 11.6931 74.2533 10.8701 73.3164 10.5935L69.978 9.61993C69.4966 9.46293 69.0672 9.17154 68.7375 8.77825C68.4079 8.38497 68.191 7.90526 68.1112 7.39266L67.7024 3.01166C67.6282 2.51418 67.4016 2.054 67.0554 1.69813C66.7092 1.34225 66.2616 1.10924 65.7776 1.03303L58.4841 0.0174522C57.5098 -0.119126 56.7024 0.549757 56.7297 1.5093V2.77352C56.6479 1.81748 60.8176 2.94512 61.7987 3.05368L63.1614 3.20427C63.6462 3.26676 64.0989 3.48708 64.4531 3.83301C64.8074 4.17894 65.0447 4.63233 65.1304 5.12687L65.6686 9.70047C65.7629 10.2071 65.995 10.6758 66.3382 11.0521C66.6813 11.4284 67.1213 11.6968 67.607 11.8262L73.9875 13.3496C74.9312 13.5772 75.5512 13.1745 75.3604 12.4355Z",
    fill: "#F8CC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9172 29.9246C75.9947 29.746 62.3682 27.0564 60.1744 5.0849L56.979 5.2635C57.9465 14.3687 62.2456 31.6826 80.9172 32.7156C81.8983 32.7682 82.6954 32.1203 82.6954 31.3148C82.6954 30.5094 81.9119 29.9596 80.9172 29.9246Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.152 1.13465L119.855 2.15023C119.371 2.22748 118.924 2.46082 118.578 2.81651C118.232 3.1722 118.005 3.6318 117.93 4.12885L117.521 8.50635C117.442 9.01959 117.225 9.50004 116.896 9.89399C116.566 10.2879 116.136 10.5799 115.654 10.7371L112.316 11.7107C111.376 11.9873 110.456 12.8103 110.272 13.5527C110.088 14.2952 110.701 14.7084 111.655 14.4808L118.022 12.9574C118.508 12.825 118.947 12.5538 119.289 12.175C119.631 11.7963 119.861 11.3256 119.954 10.8177L120.488 6.24406C120.573 5.74855 120.811 5.29419 121.166 4.94802C121.521 4.60184 121.975 4.38219 122.461 4.32147L123.824 4.17088C124.801 4.06232 125.551 4.75221 125.466 5.71176C123.486 28.3031 109.672 30.8596 104.685 31.0417C103.704 31.0767 102.907 31.6476 102.907 32.4425C102.907 33.2375 103.704 33.8853 104.689 33.8433C126.47 32.6351 128.692 9.26629 128.876 2.63701C128.88 2.41463 128.836 2.1941 128.747 1.9914C128.657 1.7887 128.526 1.60892 128.361 1.46509C128.196 1.32126 128.002 1.21698 127.792 1.15983C127.583 1.10268 127.364 1.09407 127.152 1.13465Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.329 11.1258L117.055 10.7476L114.227 11.9978L117.055 11.5111L114.138 12.7157H116.721L114.016 13.4161L116.809 12.9854L113.934 13.9029C113.934 13.9029 113.001 11.5111 114.329 11.1258Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.089 31.0557L107.107 31.1328L104.314 31.9277L107.107 31.8962L104.225 32.6456L106.77 33.1009L104.103 33.3565L106.862 33.3811L104.021 33.8363C104.021 33.8363 102.761 31.4374 104.089 31.0557Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4758 1.13462L65.7694 2.1502C66.2533 2.22641 66.7009 2.45942 67.0471 2.81529C67.3933 3.17117 67.62 3.63134 67.6941 4.12883L68.1029 8.50633C68.1822 9.01956 68.3988 9.50001 68.7285 9.89396C69.0581 10.2879 69.4879 10.5798 69.9697 10.7371L73.3082 11.7107C74.2518 11.9873 75.1682 12.8103 75.3521 13.5527C75.5361 14.2951 74.9229 14.7084 73.9657 14.4807L67.6055 12.9574C67.1193 12.8258 66.6795 12.5547 66.3375 12.1759C65.9955 11.797 65.7653 11.3259 65.674 10.8176L65.1357 6.24403C65.0511 5.74904 64.8141 5.29506 64.4596 4.94895C64.1052 4.60283 63.6519 4.38286 63.1667 4.32144L61.8041 4.17085C60.8298 4.06229 60.0803 4.75218 60.1621 5.71173C62.1447 28.3031 75.9585 30.8596 80.9424 31.0417C81.9269 31.0767 82.7206 31.6475 82.7206 32.4425C82.7206 33.2374 81.9235 33.8853 80.9424 33.8433C59.1606 32.6351 56.9361 9.26626 56.7555 2.63698C56.7044 1.67043 57.5015 0.998043 58.4758 1.13462Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8491 11.2239L69.1238 10.8457L71.9479 12.0959L69.1238 11.6091L72.0398 12.8138H69.4576L72.1625 13.5142L69.3656 13.087L72.2442 13.994C72.2442 13.994 73.1776 11.6126 71.8491 11.2239Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.089 31.1537L79.0708 31.2308L81.8608 32.0292L79.0708 31.9942L81.9528 32.7472L79.4046 33.1884L82.0754 33.4476L79.3161 33.4721L82.1572 33.9238C82.1572 33.9238 83.4142 31.5425 82.089 31.1537Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 57.4222L79.548 57.1526L76.9521 61.0959C76.9521 61.0959 91.7436 64.8045 109.591 61.1414L106.3 57.4222Z",
    fill: "#9B481E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.936 61.9398C91.4677 61.0643 87.6489 57.811 86.5622 56.2876L79.5617 57.1526L76.9658 61.0958C76.9658 61.0958 88.7254 64.2231 103.936 61.9398Z",
    fill: "#7F300F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 57.4223C101.923 58.176 97.4899 58.5392 93.0516 58.5079C88.5201 58.4702 84.0009 58.0167 79.5479 57.1526C83.7651 55.2287 88.3288 54.2384 92.9426 54.246C97.5536 54.4016 102.091 55.4806 106.3 57.4223Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7386 52.8346C99.7386 52.8346 99.7148 55.0164 101.643 55.5136C101.643 55.5136 94.0462 58.2627 84.2488 55.244C84.2488 55.244 85.8908 54.8167 86.0611 52.5615L99.7386 52.8346Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.657 40.252H85.9692C88.6945 42.4722 90.3978 44.752 90.3978 46.9408C90.4523 51.7105 86.1396 52.7191 86.0544 52.5755C86.0544 52.5755 92.9698 54.8133 99.7319 52.8486C99.6501 52.9852 95.3374 52.0432 95.2795 47.0003C95.2693 44.7765 96.9487 42.4897 99.657 40.252Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.04 39.52C98.4648 42.3006 87.5466 42.0169 84.6442 39.52C83.9356 38.8967 83.9356 36.5959 84.6442 35.969C87.5432 33.395 98.4648 33.1394 101.04 35.969C101.67 36.6554 101.67 38.8301 101.04 39.52Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7525 41.6387C90.4558 43.4983 91.287 45.2773 91.3007 46.9793C91.3279 49.8894 89.938 51.5144 88.5549 52.3829C89.4355 52.5455 90.3235 52.6624 91.2155 52.7331L91.1814 52.649C91.5316 50.7792 91.6824 48.8757 91.6311 46.9723C91.6085 45.2945 91.4857 43.6197 91.2632 41.9574C90.4213 41.8979 89.5832 41.7915 88.7525 41.6387Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.476 35.8815C100.137 39.5445 85.983 39.2083 82.2255 35.8815C81.3057 35.0655 81.3057 32.0818 82.2255 31.2658C85.9727 27.9319 100.137 27.5992 103.476 31.2658C104.293 32.1658 104.293 34.9814 103.476 35.8815Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0598 38.3224C85.0793 38.5009 85.1388 38.6723 85.2335 38.8232C86.4259 39.8738 89.7064 40.5742 93.205 40.5952C96.6116 40.5952 99.4255 39.9403 100.386 38.8897C100.461 38.7745 100.511 38.6444 100.533 38.508C98.1808 39.1567 95.7521 39.4632 93.3174 39.4185C90.5284 39.4544 87.7485 39.0854 85.0598 38.3224Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.677 4.87131C114.677 19.0614 109.604 34.4072 92.8133 34.4072C76.0221 34.4072 70.9497 19.0614 70.9497 4.87131C85.1945 0.35613 100.432 0.35613 114.677 4.87131Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.677 4.87131C114.677 19.0614 109.604 34.4072 92.8133 34.4072C76.0221 34.4072 70.9497 19.0614 70.9497 4.87131C85.1945 0.35613 100.432 0.35613 114.677 4.87131Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.757 21.5373C113.849 16.5154 114.677 10.6006 114.677 4.87129C107.588 2.65585 100.222 1.51503 92.8132 1.48486C91.9911 1.48486 91.1814 1.50004 90.3843 1.53039C91.195 6.35964 94.9287 19.1384 111.757 21.5373Z",
    fill: "#F7B53C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9872 4.85724H70.9497C70.9497 19.0473 76.0221 34.3931 92.8133 34.3931C100.676 34.3931 105.966 31.0312 109.373 25.9883C101.78 25.9693 94.3081 24.0322 87.6147 20.3474C80.9212 16.6627 75.2112 11.3433 70.9872 4.85724Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4743 32.9257C82.3516 33.8257 82.5288 34.9289 82.8149 35.181C84.4365 36.6168 88.6572 37.5834 93.3277 37.5834C97.804 37.5834 101.531 36.6659 102.825 35.2476C103.122 34.9219 103.265 33.8257 103.166 32.9292C100.185 34.5226 96.7139 35.3316 92.8269 35.3316C88.94 35.3316 85.4516 34.5226 82.4743 32.9257Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8133 8.25777C85.404 8.228 78.0386 7.08717 70.9497 4.87134C77.9476 7.54738 85.3471 8.94357 92.8133 8.99669C100.279 8.94306 107.679 7.54689 114.677 4.87134C107.588 7.08678 100.223 8.2276 92.8133 8.25777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.379 4.87126C105.345 6.67187 99.0963 7.59832 92.8133 7.62383C86.5296 7.60151 80.2796 6.67861 74.2439 4.88177C86.3652 1.22162 99.2546 1.22162 111.376 4.88177L111.379 4.87126Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9343 6.48565C84.8538 7.22273 88.8287 7.60358 92.8131 7.6238C96.7916 7.60697 100.761 7.22962 104.675 6.49615C96.829 4.99266 88.7803 4.99266 80.9343 6.49615V6.48565Z",
    fill: "#C15F0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1394 41.8524C96.1695 41.9976 95.1898 42.0632 94.2097 42.0485C94.5163 42.6298 94.4005 44.5979 94.3051 45.68C94.7446 43.1761 97.1394 41.8524 97.1394 41.8524Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2417 52.5545C96.4237 52.721 95.5922 52.8078 94.7583 52.8137C95.0512 52.3654 94.639 50.1872 94.5266 49.1926C94.9967 51.4479 97.2417 52.5545 97.2417 52.5545Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0642 53.528C97.6149 53.9407 96.1101 54.1086 94.6084 54.0253C94.6084 54.0253 94.6084 55.7763 94.9014 56.088C94.9014 56.088 98.1853 56.2596 100.669 55.4226C100.669 55.4226 98.9723 54.8237 99.0642 53.528Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2683 56.9074C82.2442 56.4688 83.2427 56.0854 84.2593 55.7588C84.2593 55.7588 86.9505 57.079 93.0415 56.8094C93.0415 56.8024 88.5618 57.8145 81.2683 56.9074Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.163 2.37083C119.163 2.37083 123.493 0.86497 127.68 1.13462C127.69 1.14163 120.216 2.39184 119.163 2.37083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1201 1.11711C58.1201 1.11711 63.1994 2.20623 66.33 2.31479C66.33 2.31479 59.2375 0.917499 58.1201 1.11711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8096 13.0765C72.8096 13.0765 77.3131 29.6864 86.6813 31.4374C86.6813 31.4374 78.4202 25.8938 72.8096 13.0765Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.529 7.50131L104.365 6.14954L103.05 8.03361L104.365 9.91769L102.529 8.56591L100.696 9.91769L102.011 8.03361L100.696 6.14954L102.529 7.50131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.475 0.840498L128.429 0.136597L127.744 1.11716L128.429 2.09421L127.475 1.39381L126.525 2.09421L127.206 1.11716L126.525 0.136597L127.475 0.840498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2749 1.46737L62.2253 0.766968L61.544 1.74402L62.2253 2.72458L61.2749 2.02068L60.3245 2.72458L61.0058 1.74402L60.3245 0.766968L61.2749 1.46737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7356 52.6175L100.672 52.1307L100.005 52.8591L100.7 53.6856L99.7424 53.0553L98.809 53.5105L99.4733 52.8136L98.7783 51.9836L99.7356 52.6175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7178 53.521C92.7178 53.521 96.4139 53.7487 99.6127 52.8206C99.6264 52.8276 97.9026 54.1759 92.7178 53.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5479 57.1526C79.5479 57.1526 92.0841 60.1713 106.3 57.4222C106.3 57.4222 93.8351 60.8962 79.5479 57.1526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9944 11.5111C99.9944 11.5111 105.769 12.0539 111.379 9.91765C111.379 9.91765 109.533 12.5652 104.089 13.4196C104.089 13.4196 107.997 13.6928 110.531 13.2656C110.531 13.2656 108.487 15.3107 106.201 15.3107C106.201 15.3107 108.586 15.843 111.379 14.1446C112.746 12.2567 113.505 9.97683 113.549 7.62384C110.582 8.99662 107.874 10.0752 99.9944 11.5111Z",
    fill: "#F8CC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2065 35.5943C97.2233 35.5951 100.202 34.9048 102.927 33.5737C102.927 33.5737 102.904 34.6663 102.628 34.9745C102.352 35.2826 98.0457 36.9566 94.0361 36.8515C94.0361 36.8515 96.5434 36.5013 97.8958 35.899C96.6608 35.8828 95.4282 35.781 94.2065 35.5943Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.497 38.9948C99.4529 39.1325 99.3777 39.2576 99.2777 39.3598C99.1776 39.462 99.0555 39.5385 98.9213 39.5831C98.4955 39.6846 95.6169 40.1889 93.4707 39.9053C93.4605 39.9053 97.7699 39.6566 99.497 38.9948Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.695 57.1701C104.695 57.1701 102.386 55.9514 101.405 55.8253C101.405 55.8253 99.7013 56.6203 95.2727 56.6868C95.8561 57.238 96.5828 57.603 97.3644 57.7374C97.3644 57.7374 102.253 57.7794 104.695 57.1701Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2092 59.1032C100.029 59.9645 101.949 60.5812 103.922 60.9383C103.922 60.9383 107.008 61.1134 107.966 60.7597L105.717 58.4133L106.624 60.4725L103.66 59.0717L105.452 60.2449C105.452 60.2449 101.238 60.0873 98.2092 59.1032Z",
    fill: "#B25932"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.477 24.2866C79.2392 22.512 79.2392 19.6349 77.477 17.8603C75.7147 16.0857 72.8576 16.0857 71.0953 17.8603C69.3331 19.6349 69.3331 22.512 71.0953 24.2866C72.8576 26.0611 75.7147 26.0611 77.477 24.2866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M113.063 7.547C114.825 5.77243 114.825 2.89529 113.063 1.12072C111.301 -0.653848 108.444 -0.653845 106.682 1.12072C104.919 2.89529 104.919 5.77243 106.682 7.547C108.444 9.32157 111.301 9.32157 113.063 7.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.9327 23.9981C77.6338 23.2927 78.445 21.3322 77.7446 19.6192C77.0441 17.9061 75.0972 17.0892 73.3961 17.7946C71.695 18.5 70.8838 20.4605 71.5842 22.1735C72.2847 23.8866 74.2316 24.7034 75.9327 23.9981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.519 7.25851C113.22 6.55314 114.031 4.59264 113.331 2.8796C112.631 1.16656 110.684 0.349673 108.983 1.05504C107.281 1.7604 106.47 3.72091 107.171 5.43395C107.871 7.14699 109.818 7.96387 111.519 7.25851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.6634 18.5963C74.52 19.6193 74.6634 20.8959 72.8577 21.0555C73.3925 21.3068 73.9899 21.5263 74.3631 22.0305C74.6944 22.4797 74.9645 23.2354 75.0208 23.7859C75.1222 23.1923 74.9851 22.6385 75.3496 22.0305C75.4816 21.8063 75.6624 21.6153 75.8785 21.4718C76.0946 21.3283 76.3402 21.2362 76.5968 21.2023C76.0192 20.8831 75.5168 20.931 75.1666 20.236C75.0296 19.9735 74.9159 19.6993 74.8267 19.4166C74.7411 19.1317 74.7712 18.6889 74.589 18.4807L74.6634 18.5963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M110.25 1.85679C110.106 2.8797 110.25 4.15635 108.444 4.31593C108.979 4.56727 109.576 4.78669 109.949 5.29097C110.281 5.74019 110.551 6.4958 110.607 7.04636C110.708 6.45271 110.571 5.89897 110.936 5.29097C111.068 5.06676 111.249 4.8757 111.465 4.73222C111.681 4.58874 111.926 4.49659 112.183 4.46274C111.605 4.14358 111.103 4.19145 110.753 3.49648C110.616 3.23391 110.502 2.95971 110.413 2.67703C110.327 2.39218 110.357 1.94934 110.175 1.74109L110.25 1.85679Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1280_2568",
    x1: 398224,
    y1: 103076,
    x2: 388295,
    y2: 58189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1280_2568",
    x1: 98996.9,
    y1: 10920.7,
    x2: 98994.2,
    y2: 12714.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1280_2568",
    x1: 131.105,
    y1: 79.1667,
    x2: 133.409,
    y2: 128.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1280_2568",
    x1: 14360.7,
    y1: 43566.9,
    x2: 7721.65,
    y2: 41026.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1280_2568",
    x1: 55.5001,
    y1: 126,
    x2: 53.2858,
    y2: 74.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1280_2568",
    x1: 114599,
    y1: 12732.8,
    x2: 114596,
    y2: 14826.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1280_2568",
    x1: 16675.9,
    y1: 53736.2,
    x2: 8825.48,
    y2: 50896.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1280_2568",
    x1: 147198,
    y1: 16383.4,
    x2: 147193,
    y2: 19083.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1280_2568",
    x1: 81.2491,
    y1: 66.0784,
    x2: 90.741,
    y2: 139.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1280_2568",
    x1: 29504.3,
    y1: 36721.2,
    x2: 21141.1,
    y2: 28875.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_2568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 120.07,
    fill: "white",
    transform: "translate(0 58.9301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1280_2568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.1893,
    height: 62.7733,
    fill: "white",
    transform: "translate(56.7202)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCupPodium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cup-podium.8c0ca306.svg";
export { ForwardRef as ReactComponent };